import React, { useEffect } from 'react';
import { IntroPage } from '../IntroPage/IntroPage';
import '@wix/design-system/styles-default.global.css';
import { useFedops } from '@wix/fe-essentials-standalone/react';
import { WixDesignSystemProvider } from '@wix/design-system';
import { BiContextProvider } from '../../context/BiContext';

export function App() {
  const fedopsLogger = useFedops();
  useEffect(() => {
    fedopsLogger.appLoaded();
  }, [fedopsLogger]);

  return (
    <BiContextProvider>
      <WixDesignSystemProvider features={{ newColorsBranding: true }}>
        <IntroPage />
      </WixDesignSystemProvider>
    </BiContextProvider>
  );
}
